import {
  handleChangeActionType,
  handleChangeAllActionType,
  handleChangeToInitStateActionType,
} from "../../actions/handleChangeAction";

const INITIAL_STATE = {
  epost: "",
};

export default function innsynPersonopplysningerFilterFormReducer(
  state = { ...INITIAL_STATE },
  action,
) {
  switch (action.type) {
    case handleChangeActionType("INNSYN_PERSONOPPLYSNINGER_FILTER_FORM"):
      return { ...state, [action.variableName]: action.payload };
    case handleChangeAllActionType("INNSYN_PERSONOPPLYSNINGER_FILTER_FORM"):
      return { ...state, ...action.payload };
    case handleChangeToInitStateActionType(
      "INNSYN_PERSONOPPLYSNINGER_FILTER_FORM",
    ):
      return { ...INITIAL_STATE };
    default:
      return state;
  }
}
